import React from "react";
import "./IntroDetails.css";
import Imagens from "../../../../components/IMAGESCOMPONENT/ImageComponent";

const IntroDetails = () => {
  return (
    <div className="intro-details-wrapper">
      <article className="intro-details">

        <h1 className="details-title">
          Cheesecake fria com Calda de Frutas Vermelhas
        </h1>

        <span className="details-date">16 de Dezembro de 2025</span>

        <img
          src={Imagens.Receita1}
          alt="Cheesecake fria com frutas vermelhas"
          className="details-image"
        />

        <p className="details-intro">
          Essa cheesecake fria é a escolha perfeita para quem busca uma sobremesa
          sofisticada, refrescante e extremamente saborosa. A combinação do
          creme suave com a acidez das frutas vermelhas cria um equilíbrio
          irresistível.
        </p>

        <h2>Ingredientes</h2>
        <ul>
          <li>200g de biscoito maisena</li>
          <li>100g de manteiga derretida</li>
          <li>300g de cream cheese</li>
          <li>1 lata de leite condensado</li>
          <li>Suco de 1 limão</li>
          <li>Frutas vermelhas a gosto</li>
        </ul>

        <h2>Modo de preparo</h2>
        <p>
          Triture os biscoitos e misture com a manteiga até formar uma base
          uniforme. Forre o fundo de uma forma. Bata o cream cheese com o leite
          condensado e o limão, despeje sobre a base e leve à geladeira por pelo
          menos 4 horas. Finalize com a calda de frutas vermelhas.
        </p>

      </article>
    </div>
  );
};

export default IntroDetails;
